import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { publicRoutes } from '../constants';
import { useAuth } from './AuthProvider';

export default function PageActivityLogger() {
  const router = useRouter();
  const { user } = useAuth();
  const lastLoggedPage = useRef('');

  useEffect(() => {
    if (!user || !router.isReady || publicRoutes.includes(router.pathname)) {
      return;
    }

    const page = router.pathname || router.asPath.split('?')[0];
    if (lastLoggedPage.current === page) return;

    lastLoggedPage.current = page;

    fetch('/api/admin/activity', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ page }),
      keepalive: true,
    }).catch(() => {
      lastLoggedPage.current = '';
    });
  }, [router.asPath, router.isReady, router.pathname, user]);

  return null;
}
